<template>
    <div class="main-wrap">
        <div alt="" class="menu-item logo left" @click="refresh()">
          <!-- <img src="assets/images/befunlogo.png"> -->
        </div>
        
        <div class="menu-item settings-wrap right">
            <div class="settings-toggle">
                <a class="settings-icon" :class="{ active: isSettingsOpen }" @click.prevent="toggleSettingsMenu"></a>
                <div class="settings-menu" :class="{ show: isSettingsOpen }">
                    <a class="settings-item" id="light-mode" @click.prevent="changeSkin(1)">{{ lang.home['HOME.LIGHT_MODE'] }}</a>
                    <a class="settings-item" id="dark-mode" @click.prevent="changeSkin(2)">{{ lang.home['HOME.DARK_MODE'] }}</a>
                </div>
            </div>
        </div>
        <div class="menu-item lang-wrap right">
            <div class="lang-toggle">
                <a class="lang-icon" :class="{ active: isLangOpen }" @click.prevent="toggleLangMenu"></a>
                <div class="lang-menu" :class="{ show: isLangOpen }">
                    <a class="lang-item lang-cn" @click.prevent="changeLanguage(2)">
                      <span class="flag-icon"></span>
                      <span class="lang-label">{{ langSelect[2].caption }}</span>
                    </a>
                    <a class="lang-item lang-tw" @click.prevent="changeLanguage(3)">
                      <span class="flag-icon"></span>
                      <span class="lang-label">{{ langSelect[3].caption }}</span>
                    </a>
                    <a class="lang-item lang-en" @click.prevent="changeLanguage(1)">
                      <span class="flag-icon"></span>
                      <span class="lang-label notranslate">{{ langSelect[1].caption }}</span>
                    </a>
                    <a class="lang-item lang-th" @click.prevent="changeLanguage(5)">
                      <span class="flag-icon"></span>
                      <span class="lang-label">{{ langSelect[5].caption }}</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="menu-item search-box">
            <span class="search-icon"></span>
            <input type="text" :placeholder="lang.home['HOME.SEARCH']" id="searchInput" v-model="searchText">
        </div>
        
        <div class="menu-item nav-sport">
          <ul class="clearfix">
            <template v-for="(sport, key) in titleSport">
              <li v-if="['N1','N2'].includes(sport.id)" @click="changeSport(sport.id)">
                  <a :class="{'current':selectedSport == sport.id && !selectedPopular}">
                    <span class="nav-icon" :class="'icon-'+sport.id"></span>
                    <span class="nav-title">{{ arr_lang.configLang[sport.titleLang] }}</span>
                  </a>
              </li>
            </template>
            <template v-for="(lge,key) in popularLeagues">
              <li @click="filterLeague(lge)">
                  <a :class="{'current':playtype == '2' && selected_league == lge.lgeid}">
                    <span class="nav-icon icon-lge"></span>
                    <span class="nav-title" :style="(cookies_lang == 'zh_CN' || cookies_lang == 'zh_TW')? 'max-width: 90px;':'max-width: 86px;'" :title="getNameByLang(lge)">{{ getNameByLang(lge) }}</span>
                  </a>
              </li>
            </template>
          </ul>
        </div>
        
    </div>
</template>
<script>
 import {
    mapGetters
  } from 'vuex'
  // import numberFilter from '@/vue/filters/vue-filter-number'
  import EventBus from '@/vue/events/event-bus'
  import accMenu from '../home/accountMenu.vue'
  import gameHeader from '../home/gameHeader.vue'

  export default {
    computed: {
      ...mapGetters([
        'account',
        'arr_sportList',
        'sportBettypeList',
        'int_marketToggle',
        'arr_selectedTemplate',
        'tvIconFlag',
        'isParlay',
        'isSpecial',
        'isVip',
        'isCorrectScore',
        'openBetCount',
        'parlaySportList',
        'fullLoading',
        'sportSelected',
        'skinTheme',
        'arr_sportCountMarket',
        'isOtr',
        'isResult',
        'showFavEvents',
        'arr_earlyEventCountByDate',
        'currentTab',
        'titleSport',
        'isGameBannerSelected', 
        'gameBannerSportId', 
        'isresult_schedule',
        'arr_lang',
        'selectedSport',
        'selected_league',
        'selected_country',
        'playtype',
      ]),
      market:function(){
        return this.$store.getters.market
      },
      selectedMarket: function(){
        return this.$store.getters.int_selectedMarket
      },
      decimals: function(){
        return this.account.showDecimals ? 2 : 0
      },
    },
    watch: {
      searchText (newVal) {
        // if (newVal.trim()) {
          // EventBus.$emit('reloadSimpleSoccerComputed')
        // }
        this.$store.dispatch('sortEvents')
      }
    },
    components:{
      // numberFilter,
      EventBus,
      accMenu,
      gameHeader,
    },
    data() {
      return {
        cookies_lang: window._cookie,
        lang: window.lang,
        odds: window.odds,
        eventId: null,
        currentTemplate: window._currentTemplate,
        customTemplate: window._customTemplate,
        companycode : window.compcode,
	      timestamp: "",
        isSelectedMarketId : [2,3,4,5,6],
        showSpecialEvent: false,
        fromSpecialEvent: false,
        showVipEvent: false,
        gameBannerImage: window._gameBannerImage,
        lobby: window.lobby,
        lobbyUrl: window.lobbyUrl,
        isVIP: window._isVIP,
        isShowMenu: false,
        moreDetails: false,
        langId: window._langid,
        revertLang:window._langid==10?'-revert':'', 
        isSettingsOpen: false,
        isLangOpen: false,
				langSelect: lang_select,
        popularLeagues:window.popularLeagues,
        searchText: '',
        selectedPopular: false,
      }
    },
    created() {
        setInterval(this.getNow, 1000);
    },
    methods: {
      getCurrentLangFromCookie() {
        const match = document.cookie.match(/(?:^|;\s*)googtrans=([^;]+)/);
        if (!match) return "en";
        const val = decodeURIComponent(match[1]);
        const parts = val.split("/");
        return parts.length >= 3 ? parts[2] : "en";
      },
      showContact(){
          let langsPost=1;
          if(this.langId==2){
              langsPost=3;
          }else if(this.langId==2){
              langsPost=3
          }else if(this.langId==3){
              langsPost=4
          }else if(this.langId==5){
              langsPost=2
          }
          //window.open('http://3singsport.win');
          window.open('https://sigma23.3swolf.com/views/page.php?pg=1&acc='+this.account.acccode+'&lang='+langsPost);
      },
      getNow: function() {
          Date.prototype.addHours= function(h){
               this.setHours(this.getHours()+h);
               return this;
          }

          var today = new Date().addHours(-12);

          var hours = today.getHours();
          //hours = hours % 12;
          //hours = hours ? hours : 12;
          hours = hours < 10 ? '0'+hours : hours;

          var minutes = today.getMinutes();
          minutes = minutes < 10 ? '0'+minutes : minutes;

          var seconds = today.getSeconds();
          seconds = seconds < 10 ? '0'+seconds : seconds;

          const time = hours + ":" + minutes + ":" + seconds;
          this.timestamp = time;
      },
      hideMenuAll(event) {
				if(event.target.id == "menu-inner")
          			return;
       			if($(event.target).closest('#menu-inner').length)
          			return;  
                this.moreDetails = false
			},
      convertCCL(ccl){
        //please don't round up
        return Math.floor(ccl);
      },
      getSportCCL () {
        if(!this.account.previewFlag){
          this.$store.dispatch('getSportCCL', {
            token: token.arr_5
          })
        }
      },
      changeTemplate(templateId, subTemplateId = null){
        this.$store.dispatch('changeTemplate', {
            templateId: templateId,
            marketKey: this.$store.getters.int_marketToggle,
            bettypeid: this.$store.getters.arr_selectedTemplate.bettypeid,
            sportId: this.$store.getters.arr_selectedTemplate.sportId,
            subTemplateId:subTemplateId
        })
        this.showMenu = false;
      },
      toTemplate(ItemplateId, IsubTemplateId){

        if(account.previewFlag){
          //alert(lang.info7);
         // return false;
        }
        
        if(ItemplateId==21){
          this.$store.commit('IS_RESULT_SCHEDULE', false)
          this.$store.commit('CURRENT_TAB', 4)
        }else if(ItemplateId==19){
          this.$store.commit('IS_PARLAY', false)
          this.$store.commit('IS_RESULT_SCHEDULE', true)
          this.$store.commit('CURRENT_TAB', 5)
        }else if(ItemplateId==20){
          this.$store.commit('IS_PARLAY', false)
          this.$store.commit('IS_RESULT_SCHEDULE', true)
          this.$store.commit('CURRENT_TAB', 7)
        }

      //  if(!this.account.previewFlag){
          if([15,14].indexOf(ItemplateId) >= 0) {
              this.$store.commit('SELECTED_WAGER_SPORT', 99)
          }

          if (ItemplateId == 14) {
              this.$store.dispatch('getOpenBet', {
                  wgrTyp: 'openBet',
                  perPage: 10,
                  token: token.arr_2,
              })
          }
          this.$nextTick(() => {
            this.$store.dispatch('changeTemplate', {
                templateId: ItemplateId,
                subTemplateId: IsubTemplateId,
                sportId: this.$store.getters.arr_selectedTemplate.sportId,
                plytype: 1,
            });
          }); 
       // }
      },
      showMarket(market, backButton) {
        var container = $(".sub-m-menu");
        var container2 = $(".sub-background");
        if (container || container2) {
            container.hide();
            container2.hide();
        }
        this.$store.commit('SHOW_FLOATING', false)
        var sprtId = 'N1'
        if(market!=3 && this.$store.getters.arr_selectedTemplate.sportId == 'G98'){
          sprtId = 'N1'
        }else{
          sprtId = this.$store.getters.arr_selectedTemplate.sportId ? this.$store.getters.arr_selectedTemplate.sportId : 'N1'
        }
        
        if(this.isGameBannerSelected){
          sprtId = this.gameBannerSportId
        }
        var bettypeid = null
        var plytype = 1
        var subTemplateId = 1
        var marketCap = null
	
        if(this.fromSpecialEvent){ //switch from tab special event, eg: Euro 2020
          this.fromSpecialEvent = false
        } 

        if(market==1){
          marketCap = 'today'
        }else if(market==2){
          marketCap = 'early'
        }else if(market==3){
          marketCap = 'live'
        }else if(market==7){
          marketCap = 'schedule'
        }
        
        EventBus.$emit('marketChange', market)
        if(account.previewFlag || (account.previewFlag==undefined && market=='3')){
         this.$store.commit('S_ODD', true)
        }else{
          this.$store.commit('S_ODD', false)
        }
        this.$store.commit('ARR_LEAGUES', [])
        this.$store.commit('SELECTED_LEAGUES', [])
        this.$store.commit('SEL_MATCH', false)
        this.$store.commit('SELECTED_LEAGUE', [])
        this.$store.commit('SORTEDEVENTLIST', [])
        this.$store.commit('SPORT_SELECTED', false)
        this.$store.dispatch('getEventList', {
          market: market,
          token: token.arr_2,
          callback: ((res) => {
            this.$store.commit('MARKETTOGGLE', market) 
            if((account.previewFlag==undefined) || (account.previewFlag && market!='1')){//(account.previewFlag==undefined && market!='3') ||
              var btemplateId = 1;
            } else if ((account.previewFlag && market=='1')){ //|| (account.previewFlag==undefined && market=='3')
              var btemplateId = 3;
              this.$store.commit('SEL_MATCH', true)
            } 
	
            if(sprtId!='' && sprtId != 'G98' && !this.isGameBannerSelected){
              if(this.$store.getters.arr_sportList != null && Object.keys(this.$store.getters.arr_sportList).length > 0){
                let current1stSport = Object.keys(res.totalMatch)[0]
                if(market==1){
                // check have rb sport or not
                  if(this.$store.getters.arr_sportCountMarket.live && Object.keys(this.$store.getters.arr_sportCountMarket.live).length>0){
                    let rbSport = Object.keys(this.$store.getters.arr_sportCountMarket.live)[0]
                    if(rbSport<=current1stSport){
                      current1stSport = rbSport
                    }
                  }
                }

                let getSport = _.filter(this.$store.getters.titleSport, function(x){
                  return _.includes(x.sid, current1stSport)
                })

                // check selected sport exist in today/early, if not, change to existing sport
                if(this.$store.getters.market_button_toggle && sprtId != 'G3') {
                  let currSport = _.filter(this.$store.getters.titleSport, function(x){
                    return x.id == sprtId
                  })
                  let currSportId = currSport[0].sid[0]
                  if(this.$store.getters.arr_sportList[currSportId] == null) {
                    sprtId = (getSport && getSport.length > 0)? getSport[0].id : 'N1'
                  }
                }

                bettypeid = sprtId.split('')
                if(bettypeid.length >= 3){
                  bettypeid = bettypeid[1]+""+bettypeid[2]
                }else{
                  bettypeid = bettypeid[1]
                }
              }
            }

            if(!backButton){
              this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                // templateId: 2, //4
                marketKey: market,
                plytype: plytype,
                bettypeid: bettypeid,
                sportId: sprtId,
                subTemplateId: subTemplateId,
              })
            }
            
            EventBus.$emit('enableLoading', false)

            if(this.moreDetails){
              this.moreDetails = false
            }
            this.$nextTick(() => {
              this.$store.commit('SELECTED_MARKET', market)
              EventBus.$emit('marketChange', market)
              this.$store.commit('MARKETTOGGLE', market)
              EventBus.$emit('sportTemplate', sprtId)
              $('.chkbox_league').prop('checked', false)
            })
            
          }).bind(this)
        })
      },
      checkMarket(market, value=null, buttonClick=false){
        if(account.previewFlag){
          if(value == '1'){ //parlay
            alert(lang.info7);
            return false;
          }
        }
        this.$store.commit('SELECT_ALL_LEAGUE', true)
        this.$store.commit('FILTER_SELECT_ALL', true)
        this.$store.commit('MARKET_BUTTON_TOGGLE',buttonClick)
        var container = $(".sub-m-menu");
        var container2 = $(".sub-background");
        if (container || container2) {
            container.hide();
            container2.hide();
        }
        this.$store.commit('SHOW_FLOATING', false)
        // $( ".scroll" ).scrollTop( 0 );
        // this.$store.commit('LOADGAMEHEADER', true)
        this.$store.commit('IS_CORRECTSCORE', false)
        this.$store.commit('SELECTED_STATE', '')
        if(this.$store.getters.showCalendarBox){
          this.$store.commit('SHOW_CALENDAR', false)
        }
        this.$store.commit('IS_OTR', false)
        EventBus.$emit('enableLoading', true)
        // this.$store.commit('LOADINGSCREEN', true)
        this.$store.commit('SWIPE_MODE', 1)
        $('.odd-t-i-wrapper').removeClass('status2') // swipe right
        $('.standard-odd-l-w').removeClass('status2')
        this.$store.commit('VIRTUAL_DATA_LIST', [])
        // $('.match-list-container').css('padding-top','')
        
        this.$store.commit('COOKIE_LEAGUE', {
            remove : true,
        })
        
        if(value != null){
          if(value == '1'){ //parlay
            if(account.previewFlag){
              alert(lang.info7);
              return false;
            }
            this.$store.commit('IS_PARLAY', true)
            this.$store.commit('IS_SPECIAL', false)
            this.$store.commit('IS_COMBOBET', false)
            this.$store.commit('SHOW_CALENDAR', true)
            this.$store.commit('IS_RESULT_SCHEDULE', true)
            this.$store.commit('CURRENT_TAB', 4)
            this.$store.commit('MARKETTOGGLE', market)
            // this.changeParlayTemplate(market)
            this.showParlayMarket(market)
          } else if(value == '2'){ // outright
            this.$store.commit("GAMEBANNER_SELECTED", false)
            this.$store.commit('IS_PARLAY', false)
            this.$store.commit('IS_SPECIAL', false)
            this.$store.commit('IS_VIP', false)
            this.$store.commit('MARKETTOGGLE', market)
            this.$store.commit('IS_COMBOBET', false)
            this.$store.commit('BETTING_SELECTION', [])
            this.$store.commit('IS_RESULT_SCHEDULE', false)
            this.$store.commit('CURRENT_TAB', 3)
            this.showOutright(market)
          } else if(value=='99'){ //VIP event
              // this.fromSpecialEvent = true
              this.$store.commit('IS_VIP', true)
              this.$store.commit('IS_PARLAY', false)
              this.$store.commit('IS_SPECIAL', false)
              this.$store.commit('IS_COMBOBET', false)
              this.$store.commit('S_ODD', true)
              this.$store.commit('IS_RESULT_SCHEDULE', false)
              this.changeSpecialTemplate(market)
          } else { //special event
              this.fromSpecialEvent = true
              this.$store.commit('IS_PARLAY', false)
              this.$store.commit('IS_SPECIAL', true)
              this.$store.commit('IS_VIP', false)
              this.$store.commit('S_ODD', true)
              this.$store.commit('IS_COMBOBET', false)
              this.$store.commit('IS_RESULT_SCHEDULE', false)
              this.changeSpecialTemplate(market)
          }
        }else{
            if(this.isParlay && this.$store.getters.bettingSelection && this.$store.getters.bettingSelection.length > 0){
              // this.$store.commit('BETTING_SELECTION', {
              //     isOffCombo: true,
              // })
              this.$store.commit('IS_PARLAY', true)
            } else {
              this.$store.commit('IS_PARLAY', false)
            }
            this.$store.commit('IS_SPECIAL', false)
            this.$store.commit('IS_VIP', false)
            this.$store.commit('MARKETTOGGLE', market)
            if(market == 1){
              this.$store.commit('CURRENT_TAB', 1)
            }else if(market == 2){
              this.$store.commit('TODAYRBEVENTLIST', [])
              this.$store.commit('SORTEDTODAYRBEVENTLIST', [])
              this.$store.commit('CURRENT_TAB', 2)
              this.$store.commit('SHOW_CALENDAR', true)
            }
            this.showMarket(market)
        }
        this.startTimer()
      },
      modifySportId(){
        if(this.arr_sportList.propertyIsEnumerable(1)){
          return 'N1'
        }else if(this.arr_sportList.propertyIsEnumerable(2) || this.arr_sportList.propertyIsEnumerable(13)){
          return 'G1'
        }else if(this.arr_sportList.propertyIsEnumerable(3)){
          return 'N3'
        }else if(this.arr_sportList.propertyIsEnumerable(21)){
          return 'N21'
        }else if(this.arr_sportList.propertyIsEnumerable(12)){
          return 'N12'
        }else if(this.arr_sportList.propertyIsEnumerable(24)){
          return 'N24'
        }else if(this.arr_sportList.propertyIsEnumerable(23)){
          return 'N23'
        }else if(this.arr_sportList.propertyIsEnumerable(15)){
          return 'N15'
        }else if(this.arr_sportList.propertyIsEnumerable(7) || this.arr_sportList.propertyIsEnumerable(14) || this.arr_sportList.propertyIsEnumerable(19) || this.arr_sportList.propertyIsEnumerable(20)){
          return 'G2'
        }
      },
      modifyParlaySportId(){
        if(this.parlaySportList.propertyIsEnumerable(1)){
          return 'N1'
        }else if(this.parlaySportList.propertyIsEnumerable(2) || this.parlaySportList.propertyIsEnumerable(13)){
          return 'G1'
        }else if(this.parlaySportList.propertyIsEnumerable(3)){
          return 'N3'
        }else if(this.parlaySportList.propertyIsEnumerable(21)){
          return 'N21'
        }else if(this.parlaySportList.propertyIsEnumerable(12)){
          return 'N12'
        }else if(this.parlaySportList.propertyIsEnumerable(24)){
          return 'N24'
        }else if(this.parlaySportList.propertyIsEnumerable(23)){
          return 'N23'
        }else if(this.parlaySportList.propertyIsEnumerable(15)){
          return 'N15'
        }else if(this.parlaySportList.propertyIsEnumerable(7) || this.parlaySportList.propertyIsEnumerable(14) || this.parlaySportList.propertyIsEnumerable(19) || this.parlaySportList.propertyIsEnumerable(20)){
          return 'G2'
        }
      },
      showMenu(){
        this.moreDetails = false
          $('#accountMenu').addClass('on')
      },
      checkMarketId(id){
        return this.isSelectedMarketId.includes(id);
      },
      changeParlayTemplate(market){
        
          this.$store.commit('IS_PARLAY', true)
          this.$store.commit('MARKETTOGGLE', market)
          // if(((this.$store.getters.int_marketToggle == '1' || this.$store.getters.int_marketToggle == '2' ) && subTemplateId == 2)
          //     || (this.$store.getters.int_marketToggle == '2' && subTemplateId == 1)) {
          //         this.$store.commit('SELECTED_PAYLAY_DATE', 99)
          //     if(this.$store.getters.int_marketToggle == '1' && subTemplateId == 2) {
          //         this.$store.commit('SELECTED_PAYLAY_DATE', 0)
          //     }
          //     this.selectedDate = this.int_selectedParlayDate
          // }
          var sprtId = 'N1'
          var bettypeid = null
          var plytype = 1
          var subTemplateId = 2 // parlay

          if(this.parlaySportList != null && Object.keys(this.parlaySportList).length > 0){
            sprtId = this.modifyParlaySportId()
            bettypeid = sprtId.split('')
            if(bettypeid.length >= 3){
              bettypeid = bettypeid[1]+""+bettypeid[2]
            }else{
              bettypeid = bettypeid[1]
            }
          }
          
          this.$store.commit('FULL_LOAD', true)
          this.$store.commit('ARR_LEAGUES', [])
          this.$store.commit('SELECTED_LEAGUES', [])
          this.$store.commit('SEL_MATCH', false)
          this.$store.commit('SELECTED_LEAGUE', [])
          this.$store.commit('SPORT_SELECTED', false)
          if(this.fullLoading){
            if(this.parlaySportList != null && Object.keys(this.parlaySportList).length >0){
                var sSport = _.keys(this.parlaySportList)[0].toString()
                if(this.arr_selectedTemplate.sportId != null){
                  this.checkSportList(this.arr_selectedTemplate.sportId)
                }
                if(!this.sportSelected){
                  if(sSport == 1){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N1')
                  }else if(sSport == 2 || sSport == 13){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'G1')
                  }else if(sSport == 3){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N3')
                  }else if(sSport == 21){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N21')
                  }else if(sSport == 12){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N12')
                  }else if(sSport == 24){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N24')
                  }else if(sSport == 23){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N23')
                  }else if(sSport == 15){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'N15')
                  }else if(sSport == 7 || sSport == 14 || sSport == 19 || sSport == 20){
                      this.$set(this.arr_selectedTemplate, 'sportId', 'G2')
                  }
                }
            }
        }
        sprtId = this.arr_selectedTemplate.sportId
        
        this.$store.dispatch('changeTemplate', {
            templateId: 21,
            marketKey: market,
            plytype: plytype,
            bettypeid: bettypeid,
            sportId: sprtId,
            subTemplateId: subTemplateId,
        })
        this.$store.commit('FULL_LOAD', false)
        EventBus.$emit('parlaySportTemplate', sprtId)
      },
      showParlayMarket(market, backButton) {
        this.$store.commit('IS_PARLAY', true)
        var sprtId = 'N1'
        // var sprtId = this.$store.getters.arr_selectedTemplate.sportId ? this.$store.getters.arr_selectedTemplate.sportId : 'N1'
        var bettypeid = null
        var plytype = 1
        var subTemplateId = 2
	
        if(this.parlaySportList != null && Object.keys(this.parlaySportList).length > 0){
          sprtId = this.modifyParlaySportId()
          bettypeid = sprtId.split('')
          if(bettypeid.length >= 3){
            bettypeid = bettypeid[1]+""+bettypeid[2]
          }else{
            bettypeid = bettypeid[1]
          }
        }

        if(!backButton){
          this.$store.dispatch('changeTemplate', {
              templateId: 21,
              marketKey: market,
              plytype: plytype,
              bettypeid: bettypeid,
              sportId: sprtId,
              subTemplateId: subTemplateId,
          })
        }
        
       
        if(account.previewFlag || (account.previewFlag==undefined && market=='3')){
        //  this.$store.commit('S_ODD', true)
        }else{
          this.$store.commit('S_ODD', false)
        }
        this.$store.commit('ARR_LEAGUES', [])
        this.$store.commit('SELECTED_LEAGUES', [])
        this.$store.commit('SEL_MATCH', false)
        this.$store.commit('SELECTED_LEAGUE', [])
        this.$store.commit('SORTEDEVENTLIST', [])
        this.$store.commit('SPORT_SELECTED', false)
        this.$store.dispatch('getEventList', {
          market: 0,
          token: token.arr_2,
          callback: ((res) => {
            this.$store.commit('MARKETTOGGLE', market) 
            EventBus.$emit('enableLoading', false)

            if(this.moreDetails){
              this.moreDetails = false
            }
            this.$store.commit('SELECTED_MARKET', market)
            EventBus.$emit('marketChange', market)
            EventBus.$emit('parlaySportTemplate', sprtId)
            $('.chkbox_league').prop('checked', false)
            
          }).bind(this)
        })
      },
      changeSpecialTemplate(market){
          var sprtId = 'N1'
          var plytype = 1
          var subTemplateId = 1

          var bettypeid = sprtId.split('')
          if(bettypeid.length >= 3){
            bettypeid = bettypeid[1]+""+bettypeid[2]
          }else{
            bettypeid = bettypeid[1]
          }

          EventBus.$emit('marketChange', market)
          this.$store.commit('ARR_LEAGUES', [])
          this.$store.commit('SELECTED_LEAGUES', [])
          this.$store.commit('SEL_MATCH', false)
          this.$store.commit('SELECTED_LEAGUE', [])
          this.$store.commit('SORTEDEVENTLIST', [])
          this.$store.commit('FULL_LOAD', true)
          this.$store.dispatch('getEventList', {
            market: market,
            token: token.arr_2,
            callback: ((res) => {
              this.$store.commit('MARKETTOGGLE', market)					
              this.$store.dispatch('changeTemplate', {
                templateId: 2, //4
                marketKey: market,
                plytype: plytype,
                bettypeid: bettypeid,
                sportId: sprtId,
                subTemplateId: subTemplateId,
              })
              this.$store.commit('SELECTED_MARKET', market)
              this.$store.commit('FULL_LOAD', false)
              EventBus.$emit('sportTemplate', sprtId)
              $('.chkbox_league').prop('checked', false)
            }).bind(this)
          })
      },
      startTimer() {
          if(this.int_marketToggle == 3){
              this.timerSeconds = 10
          }
          if(this.timerId == null){
              this.timerId = setInterval(() => {
                  if(!this.bettingFormToggle){
                      if(!this.bettingMessage){
                          if(this.timerSeconds - 1 < 0) {
                              this.reloadTable(token.arr_1)
                              this.refreshTimer();
                          } else {
                              this.timerSeconds -= 1;
                          }
                      }
                  }
              },1000);
          }
      },
      refreshTimer () {
          this.clearTimer()
          this.timerSeconds = 60
          if(this.int_marketToggle == 3){
            this.timerSeconds = 10
          }
          this.startTimer()
      },
      clearTimer() {
          clearInterval(this.timerId)
          this.timerId = null
      },
      reloadTable(token_val=null){
          // if(this.$store.getters.arr_selectedTemplate.templateId == '2'){
          // // if(this.arr_selectedTemplate.templateId == '2'){
          //     if(this.$store.getters.arr_selectedTemplate.subTemplateId == '3'){
          //     // if(this.arr_selectedTemplate.subTemplateId == '3'){
          //         this.$store.dispatch('getOutrightLeague', { token: token_val })
          //     }else{
          //         if(!this.$store.getters.s_odd){
          //             if(this.$store.getters.int_marketToggle=='1'){
          //               this.$store.dispatch('getTodayRBSportOdds', { loading:1, token: token_val })
          //             } else {
          //               this.$store.dispatch('getSportOdds', { loading:1, token: token_val })
          //             }
          //             if(this.int_marketToggle==3){
          //               this.$store.dispatch('getLiveSportOdds', {
          //                 loading: 1,
          //                 token: token_val,
          //               })
          //             }else{
          //               /*
          //               this.$store.dispatch('getSportOdds', {
          //                 loading: 1,
          //                 token: token_val,
          //               })*/
          //             }
          //         } else {
          //           if(this.$store.getters.isSpecial){
          //             this.$store.dispatch('getSpecialEventOdds', {
          //                 loading: 1,
          //                 token: token_val,
          //             })
          //           } else if(this.$store.getters.isVip && !this.$store.getters.isSpecial){
          //             this.$store.dispatch('getVipEventOdds', {
          //                 loading: 1,
          //                 token: token_val,
          //             })
          //           } else {
          //             if(this.int_marketToggle == '3'){
          //               this.$store.dispatch('getLiveSportOdds', {
          //                 loading: 1,
          //                 token: token_val,
          //               })
          //             }else{
          //               this.$store.dispatch('getSportOdds', {
          //                   loading: 1,
          //                   token: token_val,
          //               })
          //             }
          //           }
                      
          //         }
          //     }
          // }else if(this.$store.getters.arr_selectedTemplate.templateId == '6'){
          //     this.$store.dispatch('getSportAllBet', {
          //         event: this.$store.getters.arr_selectedEvent,
          //         loading: '1',
          //         token: token_val,
          //     })
          // }else{
          //     if(this.$store.getters.arr_selectedTemplate.subTemplateId == '3'){
          //         this.$store.dispatch('getSportOutrightOdds', { token: token_val })
          //     }else{
          //         //this.$store.dispatch('getSportOdds', {
          //         //    loading: 1,
          //         //    token: token_val,
          //         //})
          //         // this.getSportCCL()
          //     }
              
          // }
          this.refreshTimer()
      },
      checkSportList(sport) {
        let STORE = this
        var sportId = []
        if(sport == 'N1'){
          sportId = ['1']
        }else if(sport == 'G1'){
          sportId = ['2', '13']
        }else if(sport == 'N3'){
          sportId = ['3']
        }else if(sport == 'N21'){
          sportId = ['21']
        }else if(sport == 'N12'){
          sportId = ['12']
        }else if(sport == 'N24'){
          sportId = ['24']
        }else if(sport == 'N23'){
          sportId = ['23']
        }else if(sport == 'N15'){
          sportId = ['15']
        }else if(sport == 'G2'){
          sportId = ['7', '14', '19', '20']
        }

        if(this.isParlay){
          var s = _.keys(this.parlaySportList)
          _.each(sportId, function(val){
            if(_.includes(s, val)){
              STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport)
              STORE.$store.commit('SPORT_SELECTED', true)
            }
          })
        }else{
          var d = _.keys(this.$store.getters.arr_sportList)
          _.each(sportId, function(val){
            if(_.includes(d, val)){
              STORE.$set(STORE.$store.getters.arr_selectedTemplate, 'sportId', sport)
              STORE.$store.commit('SPORT_SELECTED', true)
            }
          })
        }
      },
      showLobby() {
        if(this.lobby != '' && this.lobbyUrl != ''){
          if(this.lobby != null && this.lobbyUrl != null){
            return true
          }
        }
        return false
      },
      backToLobby() {
        if(window.self !== window.top){
          window.top.location.href =this.lobbyUrl
        }else{
          window.location.href = this.lobbyUrl
        }
      },
      showAccMenu() {
        var container = $(".sub-m-menu");
        var container2 = $(".sub-background");
        if (container || container2) {
            container.hide();
            container2.hide();
        }
        this.$store.commit('SHOW_FLOATING', false)
        $('.c-set-menu').show()
        this.isShowMenu = true
      },
      modifySportCount(market, value=null){
        let Vue = this
        let sptCount = Vue.arr_sportCountMarket
        let count = []
        let earlyCount = Vue.arr_earlyEventCountByDate

        if(market==1){
          $.each(sptCount['live'], function(sport, val){
            count.push(val)
          })
          $.each(sptCount['today'], function(sport, val){
            count.push(val)
          })
        }else if(market==2){
          if(value==2){
            $.each(sptCount['otr'], function(sport, val){
              count.push(val)
            })
          }else{
            $.each(sptCount['early'], function(sport, val){
              count.push(val)
            })
            // $.each(earlyCount, function(sport, val){
            //   count.push(val['ttl'])
            // })
          }
        }else if(market==3){
          $.each(sptCount['live'], function(sport, val){
            count.push(val)
          })
        }
        return _.sum(count)
      },
      showMoreDetails(val) {
        this.$store.commit('IS_HIDE_LEAGUE', false)
        this.$store.commit('EDITIONSTAND', 3)
        var container = $(".sub-m-menu");
        var container2 = $(".sub-background");
        if (container || container2) {
            container.hide();
            container2.hide();
        }
        this.$store.commit('SHOW_FLOATING', false)
        this.$store.commit('FILTERLEAGUELIST', [])
        this.$store.commit('SC_CS_HIDE', {}) 
        this.$store.commit('SET_SUBMENU_STATUS', {})
        
        $( ".scroller" ).scrollTop( 0 );
        console.log(this.$store.getters.int_marketToggle)
        if(val==1){
          this.checkMarket(this.$store.getters.market.inPlayMarket.key);
        }else if(val==2){
          this.checkMarket(this.$store.getters.market.tdyMarket.key);
        }else if(val==3){
          this.checkMarket(this.$store.getters.market.earlyMarket.key)
        }else if(val==4 && !this.isOtr){
          this.checkMarket(this.$store.getters.market.earlyMarket.key, 2)
        }else if(val==5 && !this.isParlay){
          this.checkMarket(this.$store.getters.market.earlyMarket.key, 1)
        }else if(val==6 && this.$store.getters.arr_selectedTemplate.templateId!=19){
          this.toTemplate(19,1);
        }else if(val==7 && (this.isOtr || this.isParlay || this.$store.getters.int_marketToggle!=1) ){
          this.toTemplate(20,1);
        }else{
          if(this.moreDetails){
          this.moreDetails = false
          }else{
            this.moreDetails = true
          }
        }
      },
      showOutright(market, backButton) {
        this.$store.commit('IS_OTR', true)
        
        var sprtId = 'N1'
        var bettypeid = null
        var plytype = 1
        var subTemplateId = 3
        var marketCap = 'otr'
	
        if(this.fromSpecialEvent){ //switch from tab special event, eg: Euro 2020
          this.fromSpecialEvent = false
        } 
        // else {          
        //   sprtId = this.modifySportId()
        // }
	
        if(this.$store.getters.arr_sportList != null && Object.keys(this.$store.getters.arr_sportList).length > 0){
          sprtId = this.modifySportId()
          bettypeid = sprtId.split('')
          if(bettypeid.length >= 3){
            bettypeid = bettypeid[1]+""+bettypeid[2]
          }else{
            bettypeid = bettypeid[1]
          }
        }
        
        EventBus.$emit('marketChange', market)
        if(account.previewFlag || (account.previewFlag==undefined && market=='3')){
      //    this.$store.commit('S_ODD', true)
        }
        if(this.$store.getters.editionStand == 3){
          this.$store.commit('EDITIONSTAND', 1)
        }
        this.$store.commit('ARR_LEAGUES', [])
        this.$store.commit('SELECTED_LEAGUES', [])
        this.$store.commit('SEL_MATCH', false)
        this.$store.commit('SELECTED_LEAGUE', [])
        this.$store.commit('SORTEDEVENTLIST', [])
        this.$store.commit('SPORT_SELECTED', false)
        this.$store.dispatch('getEventOutright', {
          market: market,
          token: token.arr_2,
          callback: ((res) => {
            this.$store.commit('MARKETTOGGLE', market) 
            if((account.previewFlag==undefined) || (account.previewFlag && market!='1')){//(account.previewFlag==undefined && market!='3') ||
              var btemplateId = 5;
            } else if ((account.previewFlag && market=='1')){ //|| (account.previewFlag==undefined && market=='3')
              var btemplateId = 3;
              this.$store.commit('SEL_MATCH', true)
            } 
            if(this.$store.getters.arr_sportCountMarket != null && Object.keys(this.$store.getters.arr_sportCountMarket).length >0){
              var sSport = this.$store.getters.arr_sportCountMarket[marketCap] ? _.keys(this.$store.getters.arr_sportCountMarket[marketCap])[0].toString() : 1
              if(this.arr_selectedTemplate.sportId != null){
                // this.checkSportList(this.arr_selectedTemplate.sportId)
              }
              
              if(!this.sportSelected){
                if(sSport == 1){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N1')
                }else if(sSport == 2){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N2')
                }else if(sSport == 13){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N13')
                }else if(sSport == 3){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N3')
                }else if(sSport == 21){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N21')
                }else if(sSport == 12){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N12')
                }else if(sSport == 24){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N24')
                }else if(sSport == 23){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N23')
                }else if(sSport == 15){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N15')
                }else if(sSport == 7){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N7')
                }else if(sSport == 14){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N14')
                }else if(sSport == 19){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N19')
                }else if(sSport == 20){
                    this.$set(this.$store.getters.arr_selectedTemplate, 'sportId', 'N20')
                }
              }
            }
            
            sprtId = (this.$store.getters.arr_selectedTemplate.sportId == undefined) ? sprtId : this.$store.getters.arr_selectedTemplate.sportId;
            
            if(!backButton){
              this.$store.dispatch('changeTemplate', {
                templateId: btemplateId,
                // templateId: 2, //4
                marketKey: market,
                plytype: plytype,
                bettypeid: bettypeid,
                sportId: sprtId,
                subTemplateId: subTemplateId,
              })
            }

            EventBus.$emit('enableLoading', false)

            if(this.moreDetails){
              this.moreDetails = false
            }
            
            this.$store.commit('SELECTED_MARKET', market)
            EventBus.$emit('sportOutrightTemplate', sprtId)
            $('.chkbox_league').prop('checked', false)
            
          }).bind(this)
        })
      },
      toggleSettingsMenu() {
        this.isSettingsOpen = !this.isSettingsOpen;
        this.isLangOpen = false;
      },
      toggleLangMenu() {
        this.isLangOpen = !this.isLangOpen;
        this.isSettingsOpen = false;
      },
      changeSkin(theme) {
        this.isSettingsOpen = false;
        if(theme != this.$store.getters._theme){
          this.$store.commit('SKIN_THEME', theme)
          if(this.account.previewFlag){
            this.$ajax({
              url: _baseUrl + '/account-def-settings',
              type: 'get',
              data: {
                action: 'previewSetting',
                theme: this.$store.getters._theme
              }
            }).done(response => {
              
            })
          }
        }
        if(theme == 2){
          document.documentElement.classList.add('theme02');
        }else{
          document.documentElement.classList.remove('theme02');
        }
				
			},
      changeLanguage(selectedLangauge) {
        this.isLangOpen = false;
        if (selectedLangauge == 5) {
        // Thai
          this.setGoogTransCookie('/auto/th');
        } else {
          // English (reset)
          this.clearGoogTransCookie();
        }
        this.$ajax({
          url: '',
          type: 'get',
          data: {
            language: selectedLangauge,
            token: token.arr_3,
            action: 'changeLanguage',
          },
        }).then(response => {
          var url = window.location.href
          //if url has param langs, eg. preview?sport=2&langs=3&ot=2&hdp=0
          if (url.indexOf('langs') != -1) {
            var url_temp = url.split("langs") // [0]:preview?sport=2&' [1]:'=3&ot=2&hdp=0'
            // check if the last char of first part url after split has '&', if yes remove '&''
            var new_url = url_temp[0].slice(-1) == '&'? url_temp[0].slice(0, -1) : url_temp[0]
            // check if the second part url after split contains others params by checking '&'
            if(url_temp[1].indexOf('&') != -1) {
              var url_rest = url_temp[1].split(/&(.*)/) // get the rest param, eg. '=3&ot=2&hdp=0' => 'ot=2&hdp=0'
              window.location.href = new_url + (new_url.slice(-1) == '?'? '':'&') + url_rest[1]
            } else {
              window.location.href = new_url
            }
          } else {
            window.location.reload();
          }
        });
        // this.forceReload();
			},
      // forceReload() {
      //   window.location.href =
      //     window.location.pathname + window.location.search;
      // },
      loadGoogleTranslateScript() {
        if (window.google && window.google.translate) return;
        if (document.getElementById("google-translate-script")) return;

        const script = document.createElement("script");
        script.id = "google-translate-script";
        script.src =
          "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

        window.googleTranslateElementInit = () => {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: "en",
              autoDisplay: false,
            },
            "google_translate_container"
          );
        };

        document.body.appendChild(script);
      },
      setGoogTransCookie(val) {
        const rootDomain = this.getRootDomain();

        document.cookie = `googtrans=${val}; path=/; max-age=31536000`;
        document.cookie = `googtrans=${val}; path=/; domain=${rootDomain}; max-age=31536000`;
      },
      clearGoogTransCookie() {
        const rootDomain = this.getRootDomain();
        const expires = "Thu, 01 Jan 1970 00:00:00 GMT";

        document.cookie = `googtrans=; expires=${expires}; path=/`;
        document.cookie = `googtrans=; expires=${expires}; path=/; domain=${rootDomain}`;
      },
      getRootDomain() {
        const host = location.hostname;
        const parts = host.split('.');

        if (parts.length >= 2) {
          return '.' + parts.slice(-2).join('.');
        }

        return host;
      },
      changeSport(sportId){
          this.selectedPopular = false;
          this.$store.commit('SELECTEDLEAGUE', null)
          this.$store.commit('PLAYTYPE', 1)
          if(this.$store.getters.selected_country){
            this.$store.commit('PLAYTYPE', 1)
          }
          EventBus.$emit('CHANGE_SPORT',sportId)
      },
      filterLeague(lge) {
          this.selectedPopular = true;
          EventBus.$emit('filterLeague', lge)
      },
      handleClickOutside(event) {
        const settings = this.$el.querySelector('.settings-toggle');
        const lang = this.$el.querySelector('.lang-toggle');

        if (
          !settings.contains(event.target) &&
          !lang.contains(event.target)
        ) {
          this.isSettingsOpen = false;
          this.isLangOpen = false;
        }
      },
      refresh() {
        window.location.reload()
      },
      getNameByLang(arr) {
        return this.cookies_lang == 'zh_CN'? arr.name_2 : (this.cookies_lang == 'zh_TW'? arr.name_3 : arr.name_1);
      },
    },
    beforeMount() {
      // var accCookie = JSON.parse(this.$cookie.get(window.compcode+ '_acc'))
      var accCookie = this.$store.getters.accSetting
      this.selectedOdd = accCookie.oddsType
      if(!this.account.previewFlag){
        this.$store.dispatch('getSportCCL', {
          token: token.arr_7
        })
      }
      if(window._gameBanner) { //special event, eg: EURO 2020
	      this.showSpecialEvent = true
      }
      if(localStorage.getItem('bts')) {
          var bts = JSON.parse(localStorage.getItem('bts'))

          if(bts.data!='' && bts.data.length>0){
            if(bts.isComboBet){
              this.checkMarket(this.int_marketToggle)  
            }else if(bts.isParlay){
              this.checkMarket(this.market.earlyMarket.key, 1)
            }else if(bts.isOtr){
              this.checkMarket(this.market.earlyMarket.key, 2)
            }
          }
      }
      EventBus.$on('euroChangeMarket', ((market) =>{
        this.checkMarket(market)
      }).bind(this))
      EventBus.$on('changeMarket', ((val) =>{
        console.log('changeMarket: '+val)
        this.showMoreDetails(val)
      }).bind(this))
      EventBus.$on('changeMatches', (function() {
        this.selectedPopular = false
      }).bind(this))
    },
    mounted() {
      EventBus.$off('euroChangeMarket')
      this.loadGoogleTranslateScript();
      this.refreshTimer()
      //   EventBus.$on('refreshOpenBetCount', ()=> {
      //   this.refreshTimer()
      //})
      document.addEventListener('click', this.handleClickOutside);
    },
    created(){
      EventBus.$on('getMatchDetail', (market)=>{
        if(this.$store.getters.market_button_toggle) {
          this.$store.commit('MARKET_BUTTON_TOGGLE',false)
        } else {
          if(this.isParlay){
            if(this.$store.getters.currentTab!='4'){
              if(this.$store.getters.currentTab=='1'){
                this.checkMarket(this.$store.getters.market.tdyMarket.key)
              } else {
                this.checkMarket(this.$store.getters.market.earlyMarket.key)
              }
            } else {
              this.checkMarket(market, 1)
            }  
          }else if(this.isOtr){
            this.checkMarket(market, 2)  
          }else{
            if(!this.$store.getters.isresult_schedule){
              this.checkMarket(market)
            }
          }
        }
        EventBus.$off('getMatchDetail')
      })
    },
    beforeDestroy(){
      document.removeEventListener('click', this.handleClickOutside);
      // EventBus.$off('getMatchDetail')
      //EventBus.$off('refreshOpenBetCount')
      //this.clearTimer()
    },
  }
</script>


// WEBPACK FOOTER //
// resources/score/vue/apps/sport/marketHeader.vue